import { render, staticRenderFns } from "./ActivatedSuccessfullyLetter.vue?vue&type=template&id=59c7d7b4"
import script from "./ActivatedSuccessfullyLetter.vue?vue&type=script&lang=js"
export * from "./ActivatedSuccessfullyLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports